import cloneDeep from 'lodash/cloneDeep';

import {
  REPORT_DETAIL_DATA_KEY,
  SECTION_DETAIL_DATA_KEY,
  UPDATE_USER_SETTINGS_KEY,
} from 'src/redux/constants';
import type { IViewDataInitialState } from 'src/redux/viewData/types';

interface ReceiveAction {
  payload?: unknown;
  request_params?: unknown;
}

interface FailureAction {
  error?: unknown;
  timestamp?: unknown;
}

interface ClearApiKeysAction {
  dataKeys: string[];
}

export const requestApiHoldingData = (
  state: IViewDataInitialState,
  key: string,
): IViewDataInitialState => ({
  ...state,
  [key]: {
    ...state[key],
    isFetching: true,
  },
});

export const requestApi = (
  state: IViewDataInitialState,
  key: string,
): IViewDataInitialState => ({
  ...state,
  [key]: { isFetching: true },
});

export const setFetchingOnDataKey = (
  state: IViewDataInitialState,
  dataKey: string | undefined,
): IViewDataInitialState => ({
  ...state,
  [dataKey || UPDATE_USER_SETTINGS_KEY]: { isFetching: true },
});

export const receiveFromApi = (
  state: IViewDataInitialState,
  action: ReceiveAction,
  key: string,
): IViewDataInitialState => ({
  ...state,
  [key]: {
    isFetching: false,
    data: action.payload,
    request_params: action.request_params,
  },
});

export const receiveFromApiHoldingData = (
  state: IViewDataInitialState,
  action: ReceiveAction,
  key: string,
): IViewDataInitialState => ({
  ...state,
  [key]: {
    ...state[key],
    data: action.payload,
    isFetching: false,
    error: undefined,
  },
});

export const requestApiFailure = (
  state: IViewDataInitialState,
  action: FailureAction,
  key: string,
): IViewDataInitialState => ({
  ...state,
  [key]: {
    isFetching: false,
    error: action.error,
    timestamp: action.timestamp,
  },
});

export const requestApiFailureHoldingData = (
  state: IViewDataInitialState,
  action: FailureAction,
  key: string,
): IViewDataInitialState => ({
  ...state,
  [key]: {
    ...state[key],
    isFetching: false,
    error: action.error,
    timestamp: action.timestamp,
  },
});

export const clearApiError = (
  state: IViewDataInitialState,
  key: string,
): IViewDataInitialState => {
  if (!state[key]) {
    return state;
  }
  return {
    ...state,
    [key]: {
      ...state[key],
      error: undefined,
      timestamp: undefined,
    },
  };
};

export const clearViewData = (): IViewDataInitialState => ({});

export const clearApiKeys = (
  state: IViewDataInitialState,
  action: ClearApiKeysAction,
): IViewDataInitialState => {
  const newState = cloneDeep(state);
  action.dataKeys.forEach(value => {
    delete newState[value];
  });
  return newState;
};

export const cleanReportData = (
  state: IViewDataInitialState,
): IViewDataInitialState => {
  const newState = { ...state };
  delete newState[SECTION_DETAIL_DATA_KEY];
  delete newState[REPORT_DETAIL_DATA_KEY];
  return newState;
};

export const resetReportsList = (
  state: IViewDataInitialState,
): IViewDataInitialState => ({
  ...state,
  ACR_REPORTS_LIST: {
    data: [],
    isFetching: false,
  },
});
